/**
 * Presença do fornecedor — delega para storePresence unificado.
 */

import type { Supplier } from '../types';
import { isStoreOpen, STORE_PRESENCE_TTL_MS, type StorePresenceEntity } from './storePresence';

export const SUPPLIER_PRESENCE_TTL_MS = STORE_PRESENCE_TTL_MS;

export type SupplierPresenceCarrier = Pick<
  Supplier,
  'id' | 'storeOnline' | 'isOpen' | 'lastSeen' | 'lastSeenAt' | 'isOnline' | 'acceptingOrders'
> | null | undefined;

export function isSupplierStoreLive(
  supplier: SupplierPresenceCarrier,
  debug = false
): boolean {
  return isStoreOpen(supplier as StorePresenceEntity, debug);
}

export const SUPPLIER_STORE_CLOSED_MESSAGE =
  'Este fornecedor está fechado no momento. Volte mais tarde ou escolha outro parceiro.';

export const SUPPLIER_STORE_CLOSED_ORDER_LABEL = 'Loja fechada — volte mais tarde';
